import axios from 'axios'
import errors from '@feathersjs/errors'

export default request = (url, {json, retry, timeout})->
	Promise.resolve()
		.then ()-> axios.post(url, json)
		.then ({data})-> data
		.catch (err)->
			if err.response?.data
				newErr = errors.convert(err.response.data)
				newErr.axiosError = err
				throw newErr
			else
				throw err